const items = [
  "Pinehurst",
  "Northgate",
  "Maple Leaf",
  "Lake City",
  "Northeast Seattle",
  "Mobile Detail Available",
  "Hand-Washed",
  "Professional Supplies",
];

export default function Marquee() {
  return (
    <section
      data-testid="marquee-section"
      className="relative bg-black border-y border-white/10 py-8 overflow-hidden"
    >
      <div className="marquee">
        <div className="marquee__track">
          {[...items, ...items].map((t, i) => (
            <span
              key={i}
              className="font-display italic text-3xl md:text-5xl outline-text tracking-tight"
            >
              {t} <span className="text-gold not-italic mx-6">✦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
